import { Card } from "react-bootstrap";
import CustomerMessages from "./CustomerMessages";
import CertificateApprovalsList from "./CertificateApprovalsList";
import useAuth from "../hooks/useAuth";

const Home = () => {
    const { auth } = useAuth();
    
    return (
        <section>
            <CustomerMessages/>
            <br/>
        </section>
    )
}

export default Home